module.exports = __webpack_public_path__ + "img/微信.cfb5b7c1.svg";